module.exports = __webpack_public_path__ + "static/media/BoundWorx_Application_Data_Sheet_MARBLE.a7205b6b.pdf";